/* Coco Lane fixes layer, 15 Oct 2026. QA pass on the LIVE candidate theme.
   Loaded last from layout/theme.liquid. Remove the one script tag there to switch it off.
   1. The cart's Checkout button waits for a postcard message that is still saving, then carries on.
      Typing a message and tapping Checkout straight away could otherwise reach checkout before the save finished.
   2. A postcard with no words gets one friendly warning. Pressing Checkout again sends it blank.
      (The cart's date step runs first: with no ship date chosen it opens the calendar, and this check
      runs on the press after that.)
   3. The corporate quote form lives in the page body, so it is tuned here: autofill hints, and an
      example date that is always a Friday about three weeks out (it said Fri 26 Sep). */
(function () {
  "use strict";
  var GO = '[name="checkout"],a[href^="/checkout"]';
  var waiting = false, warned = false;

  function boxes() { return Array.prototype.slice.call(document.querySelectorAll(".cro-cardmsg textarea")); }
  function unsaved() { return boxes().filter(function (t) { return t.dataset.croDirty === "1"; }); }

  function say(t, msg, warn) {
    var s = t.parentNode && t.parentNode.querySelector(".cro-cardmsg-status");
    if (!s) { return; }
    s.textContent = msg;
    s.className = "cro-cardmsg-status" + (warn ? " cl-warn" : "");
    if (warn) { s.setAttribute("role", "alert"); } else { s.removeAttribute("role"); }
  }

  function waitForSave(btn) {
    if (waiting) { return; }
    waiting = true;
    var tries = 0;
    unsaved().forEach(function (t) {
      say(t, "saving your card message, one moment");
      try { t.blur(); } catch (e) {}
    });
    (function poll() {
      if (!unsaved().length) { waiting = false; btn.click(); return; }
      if (++tries > 30) {
        waiting = false;
        unsaved().forEach(function (t) { say(t, "that did not save. check your connection and press checkout again", true); });
        return;
      }
      setTimeout(poll, 200);
    })();
  }

  document.addEventListener("click", function (e) {
    var btn = e.target && e.target.closest ? e.target.closest(GO) : null;
    if (!btn) { return; }
    if (unsaved().length) {
      e.preventDefault();
      e.stopImmediatePropagation();
      waitForSave(btn);
      return;
    }
    var blank = boxes().filter(function (t) { return !t.value.trim(); });
    if (blank.length && !warned) {
      warned = true;
      e.preventDefault();
      e.stopImmediatePropagation();
      say(blank[0], "your postcard has no words yet. add them, or press checkout again to send it blank", true);
      try {
        blank[0].scrollIntoView({ behavior: "smooth", block: "center" });
        blank[0].focus({ preventScroll: true });
      } catch (err) {}
    }
  }, true);

  document.addEventListener("input", function (e) {
    if (e.target && e.target.closest && e.target.closest(".cro-cardmsg")) { warned = false; }
  }, true);

  function tuneForms() {
    var q = document.querySelector('form[action*="/contact#quote"]');
    if (q) {
      var hints = { "contact[Company]": "organization", "contact[Name]": "name", "contact[email]": "email", "contact[Phone]": "tel" };
      Object.keys(hints).forEach(function (n) {
        var el = q.elements[n];
        if (el && !el.getAttribute("autocomplete")) { el.setAttribute("autocomplete", hints[n]); }
      });
      var by = q.elements["contact[Needed by]"];
      if (by) {
        var d = new Date();
        d.setDate(d.getDate() + 21);
        while (d.getDay() !== 5) { d.setDate(d.getDate() + 1); }
        var DN = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        var MN = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        by.setAttribute("placeholder", "e.g. " + DN[d.getDay()] + " " + d.getDate() + " " + MN[d.getMonth()]);
      }
    }
    /* Coco Cater order form (section cl-coco-cater): no delivery date in the past, and none for today */
    var cd = document.getElementById("clc-date");
    if (cd && !cd.min) {
      var t = new Date();
      t.setDate(t.getDate() + 1);
      cd.min = t.getFullYear() + "-" + ("0" + (t.getMonth() + 1)).slice(-2) + "-" + ("0" + t.getDate()).slice(-2);
    }
  }
  if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", tuneForms); } else { tuneForms(); }
})();
